export default __webpack_public_path__ + "static/media/cp_geo_jo.3abd5f5e.svg";